import { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import TypeSkeleton from './TypeSkeleton';
import FormHelperText from '../FormHelperText';
import { useTranslation } from 'react-i18next';
import LabeledBox from '../../special/LabeledBox';
import ExoDialog from '../../exo/ExoDialog';
import { costCenterIconMap } from '../../exo/ExoCostCenter';
import ExoAvatar from '../../exo/ExoAvatar';
import DBSearch from '../../special/DBSearch';
import CardGrid from '../../cards/layout/CardGrid';

const TypeProjectSearch = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (
      dataCollection[field.key] &&
      (!selected || dataCollection[field.key].id !== selected.id)
    ) {
      setSelected(dataCollection[field.key]);
    }
    if (!dataCollection[field.key] && selected) setSelected(null);
  }, [dataCollection[field.key]]);

  function handleChangeSelect(value) {
    setSelected(value);
    updateValidationOnChange(field.key, value);
    setOpen(false);
  }

  return (
    <Box
      sx={{
        gridColumn: field.colspan
          ? `span ${field.colspan} / span ${field.colspan}`
          : 'auto',
      }}
    >
      <LabeledBox label={field.label} onClick={() => setOpen(true)}>
        {selected && (
          <Box className="flex items-center gap-2 w-full">
            <ExoAvatar
              size="26px"
              name={selected.label}
              picture={
                dataCollection[field.key] && dataCollection[field.key]?.image
              }
              type={selected.clientType}
            />
            <Typography>{selected.label}</Typography>
          </Box>
        )}
      </LabeledBox>
      <FormHelperText />
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <SelectCostCenter
          types={field.types || ['DIRECT_COSTS']}
          onSelect={handleChangeSelect}
          onClose={() => setOpen(false)}
        />
      </ExoDialog>
    </Box>
  );
};

const SelectCostCenter = ({ onSelect, onClose, types }) => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState(null);

  return (
    <Box className="flex flex-col gap-4 overflow-y-auto h-full">
      <DBSearch param="projects" onSearch={setProjects}>
        <Typography variant="h4">{t('Projects')}</Typography>
        <CardGrid>
          {projects ? (
            projects.map((project) => (
              <Project
                key={project.id}
                project={project}
                types={types}
                onSelect={onSelect}
              />
            ))
          ) : (
            <TypeSkeleton n={25} />
          )}
        </CardGrid>
      </DBSearch>
    </Box>
  );
};

const Project = ({ project, onSelect, types }) => {
  return (
    <Button
      onClick={() => onSelect(project)}
      variant="contained"
      color="secondary"
      sx={{
        transition: 'scale 0.3s ease',
      }}
      className=" cursor-pointer w-full flex flex-col backdrop-blur-lg items-center p-4 rounded-lg"
    >
      <ExoAvatar
        picture={project.image}
        type={'company'}
        name={project.subLabel}
        size="90px"
      />
      <Typography variant="h3" className="pt-4">
        <b>{project.nr}</b>
      </Typography>
      <Typography variant="h6">{project.label}</Typography>
    </Button>
  );
};

export default TypeProjectSearch;
